export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail или имя пользователя',
      invalidEmailOrUsername: 'Неверный e-mail или имя пользователя',
      invalidCredentials: 'Недействительные учетные данные',
      invalidPassword: 'Неверный пароль',
      noInternetConnection: 'Нет соединения',
      pageNotFound_title: 'Страница не найдена',
      password: 'Пароль',
      projectManagement: 'Управление проектами',
      serverConnectionFailed: 'Не могу подключиться к серверу',
      unknownError: 'Что-то пошло не так, попробуйте позже',
      useSingleSignOn: 'Используйте единый вход',
    },

    action: {
      logIn: 'Войти',
      logInWithSSO: 'Войти с помощью единого входа',
    },
  },
};
